import { call, put, select } from 'redux-saga/effects'
import request from '@src/utility/request'
import {
    searchMaterialTypesSuccess,
    searchMaterialTypesFail,
    searchTableSuccess, 
    searchTableFail,
    searchPartnerSuccess,
    searchPartnerFail
} from '../../actions/routes'
import { selectToken } from '../../selectors/auth'
import { selectBaseUrl, selectLocale } from '../../selectors/config'
import { selectSearchQuery, selectSearchUrl } from '../../selectors/routes'
import ToastContent from '../../../components/Toast'
import { toast, Slide } from 'react-toastify'


// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export function* searchMaterialTypes() {
  
    
    const q = yield select(selectSearchQuery('materialTypes'))
    const baseURL = yield select(selectBaseUrl())
    const requestURL = yield select(selectSearchUrl('materialTypes'))
    const token = yield select(selectToken())
    const locale = yield select(selectLocale())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "User-Agent": "AFTS Web App",
        "Accept-Language":locale,
        Authorization : `Token ${token}`,
        Origin : "*"
    }
    
     
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        params: { search: q },
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${baseURL}${requestURL}`, requestOptions)
        
        if (res.data) {
            
            yield put(searchMaterialTypesSuccess(res.data))
        }
      
    } catch (e) {
       yield put(searchMaterialTypesFail([{message: e.message}]))
    }
}

// worker Saga: will be fired on TABLE_AUTOCOMPLETE action
export function* searchTable(params) {
  
    const { tableType, additionalParam } = params
    const q = yield select(selectSearchQuery(tableType))
    const baseURL = yield select(selectBaseUrl())
    const requestURL = yield select(selectSearchUrl(tableType))
    const token = yield select(selectToken())
    const locale = yield select(selectLocale())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "User-Agent": "AFTS Web App",
        "Accept-Language":locale,
        Authorization : `Token ${token}`,
        Origin : "*"
    }
    
    params = { search: '' }

    if (typeof q === 'string') {
      params = { search: q }
    } else {
      params = { search: q.value, hash: q.hash }
    }

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        params,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${baseURL}${requestURL}?${additionalParam}`, requestOptions)
        
        if (res.data) {
            
            yield put(searchTableSuccess(tableType, res.data))
        }
      
    } catch (e) {
       yield put(searchTableFail(tableType, [{message: e.message}]))
    }
}

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export function* searchSharedMaterials() {
  
    
  const q = yield select(selectSearchQuery('sharedMaterials'))
  const baseURL = yield select(selectBaseUrl())
  const requestURL = yield select(selectSearchUrl('sharedMaterials'))
  const token = yield select(selectToken())
  const locale = yield select(selectLocale())

  const myHeaders = { 
      Accept: "application/json",
      "Content-Type":"application/json",
      "User-Agent": "AFTS Web App",
      "Accept-Language":locale,
      Authorization : `Token ${token}`,
      Origin : "*"
  }
  
   
  const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      params: { search: q },
      mode:'cors',
      credentials:'include'
  }

  try {
      
      const res = yield call(request, `${baseURL}${requestURL}`, requestOptions)
      
      if (res.data) {
          
          yield put(searchMaterialTypesSuccess(res.data))
      }
    
  } catch (e) {
     yield put(searchMaterialTypesFail([{message: e.message}]))
  }
}


// worker Saga: will be fired on PARTNER_SEARCH actions
export function* searchPartner(params) {
    const { email, callback } = params
    const baseURL = yield select(selectBaseUrl())
    const requestURL = 'partnerByEmail'
    const token = yield select(selectToken())
    const locale = yield select(selectLocale())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "User-Agent": "AFTS Web App",
        "Accept-Language":locale,
        Authorization : `Token ${token}`,
        Origin : "*"
    }
    
     
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {
        const res = yield call(request, `${baseURL}${requestURL}/${email}`, requestOptions)
        
        if (res?.data && res?.data?.status === "success") yield put(searchPartnerSuccess(res?.data?.partner)) 
        else if (res?.data && res?.data?.status === "fail")  {
            yield put(searchPartnerFail([{message: res?.data?.message}]))
        }
        yield callback(res?.data)
      
    } catch (e) {
       yield put(searchPartnerFail([{message: e.message}]))
    }
}